import React from "react";
import shared from "./Disclaimer.module.scss";

export const Disclaimer = ({ children }) => (
  <div className={shared.disclaimer}>
    <div className={shared.disclaimerLabel}>Disclaimer</div>
    <div className={shared.disclaimerText}>{children}</div>
  </div>
);
